import axios from 'axios';
import UserService from './user-service';
import { store } from '@/main';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

axiosInstance.loading = false;
let isRefreshing = false;
let subscribers = [];

axiosInstance.interceptors.request.use(config => {
  const { url } = config;
  const domains = url.split('/');
  const isSipStatus = domains[domains.length - 1] === 'sip-status';
  const isLkNotifications = url.includes('lk-notifications');
  const isMassAudioUploadJobs = url.includes('mass-audio-upload-jobs');
  const isMassLcdUploadJobs = url.includes('mass-lcd-upload-jobs');
  const skipGlobalLoading = isSipStatus || isLkNotifications || isMassAudioUploadJobs || isMassLcdUploadJobs;

  if (UserService.instance.isAuth) {
    config.headers.authorization = `Bearer ${UserService.instance.token}`;
  }
  if (!axiosInstance.loading && !skipGlobalLoading) {
    store.commit('setLoading', true);
  }
  return config;
});

axiosInstance.interceptors.response.use(response => {
  if (!axiosInstance.loading) {
    store.commit('setLoading', false);
  }

  return response;
}, error => {
  if (!axiosInstance.loading) {
    store.commit('setLoading', false);
  }

  const originalRequest = error.config;

  if (error && error.response && error.response.status === 401) {
    const requestUrl = originalRequest && originalRequest.url ? originalRequest.url : '';
    const isRefreshRequest = requestUrl.indexOf('/auth/refresh') !== -1 || requestUrl.indexOf('/auth/oauth/refresh') !== -1;

    if (isRefreshRequest) {
      if (localStorage.getItem('user-token')) {
        UserService.instance.logout();
      }
      return Promise.reject(error);
    }

    if (error.response.data && error.response.data.message === 'Token has expired') {
      if (!isRefreshing) {
        isRefreshing = true;
        UserService.instance.refresh()
          .then((response) => {
            const headerToken = response.headers && response.headers.authorization
              ? response.headers.authorization.replace('Bearer ', '')
              : null;
            const token = (response.data && response.data.token) || headerToken;
            if (token && (response.status === 200 || response.status === 204)) {
              UserService.instance.token = token;
              isRefreshing = false;
              onRefreshed(UserService.instance.token);
            } else {
              isRefreshing = false;
              UserService.instance.logout();
            }
            subscribers = [];
          })
          .catch(e => {
            isRefreshing = false;
            subscribers = [];
            console.error(e);
            UserService.instance.logout();
          });
      }

      const requestSubscribers = new Promise(resolve => {
        subscribeTokenRefresh(token => {
          originalRequest.headers.authorization = `Bearer ${token}`;
          resolve(axios(originalRequest));
        });
      });

      return requestSubscribers;
    } else {
      if (localStorage.getItem('user-token')) {
        UserService.instance.logout();
      }
    }
  }
  return Promise.reject(error);
});

function subscribeTokenRefresh (cb) {
  subscribers.push(cb);
}

function onRefreshed (token) {
  subscribers.map(cb => cb(token));
}

subscribers = [];

export default axiosInstance;
